import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { leasesApi } from '@/api/leases';

export function useLeases() {
  return useQuery({
    queryKey: ['leases'],
    queryFn: () => leasesApi.list(),
  });
}

export function useActiveLease() {
  const query = useLeases();
  const active = query.data?.find((l) => l.status === 'active') ?? null;
  return { ...query, activeLease: active };
}

export function useInitiateLeaseSign(id: number) {
  return useMutation({ mutationFn: () => leasesApi.signInitiate(id) });
}

export function useVerifyLeaseSign(id: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => leasesApi.signVerify(id, code),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['leases'] });
    },
  });
}

export function useLease(id: number | null) {
  return useQuery({
    queryKey: ['lease', id],
    queryFn: () => leasesApi.get(id as number),
    enabled: id !== null,
  });
}
